import CustomerPresenceTableView from "components/Customers/Presence";
import Layout from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";

export default function CustomerProductPresenceIndex() {
  return (
    <PageSection
      display="flex"
      flexFlow="column"
      height="100%"
      width="100%"
      padding={0}
    >
      <HeadTitle title="Customer Product Presence" />

      <CustomerPresenceTableView />
    </PageSection>
  );
}

CustomerProductPresenceIndex.getLayout = (page: React.ReactElement) => (
  <Layout isFullHeight>{page}</Layout>
);
